import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";
import { ACTION_TYPE_ENUM, actions } from "./actions";
import { useCallback, useState } from "react";
import { useStores } from "stores";
import { ButtonProps } from "antd";
import { useNotificationContext } from "providers";

export type Props = ButtonProps & {
  actionType: keyof typeof ACTION_TYPE_ENUM;
  bidId: string;
  tooltip?: string;
};

export const ColumnActionBtn = observer(({ bidId, actionType, tooltip, ...btnProps }: Props) => {
  const { nominalAccounts, actionModals, rubWithdrawalRequests } = useStores();
  const { openNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    try {
      setLoading(true);
      await actions.handlers[actionType]({
        bidId,
        openNotification,
        stores: { nominalAccounts, actionModals, rubWithdrawalRequests },
      });
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  }, [actionType, bidId, nominalAccounts, actionModals, openNotification, rubWithdrawalRequests]);

  return (
    <CustomButton
      onClick={handleClick}
      disabled={loading}
      loading={loading}
      size="small"
      tooltip={tooltip}
      {...btnProps}
    >
      {actions.btnTitles[actionType]}
    </CustomButton>
  );
});
